import { render } from "./Table.vue?vue&type=template&id=5bc753fa&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=5bc753fa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc753fa"]])

export default __exports__